<template>
  <div>
    <div class="cv-card">
      <h3 class="title">Update Resume File</h3>
      <label class="uploader">
        <div>
          <i class="fas fa-folder"></i>
        </div>
        <div class="upload-button-group">
          <input
            type="file"
            name="resumes"
            ref="fileinput"
            @input="selectFile"
          />
          <h3 v-if="!resumes.seeker.resume.fileId.src">Upload Resume</h3>
          <h3 v-if="name">{{ name }}</h3>
          <h3 v-if="!uploaded">{{ resumes.seeker.resume.fileId.link }}</h3>
          <h3>{{ error }}</h3>
          <p>Supported file type .docx .pdf | Maximum 5mb</p>
          <!-- {{forms.file}} -->
        </div>
      </label>
    </div>

    <div class="cv-card">
      <h3 class="title">Professional Summary</h3>
      <textarea
        name=""
        id=""
        cols="30"
        rows="5"
        class="textarea"
        v-model="forms.professionalSummary"
      ></textarea>
    </div>

    <div class="cv-card" v-if="resumes.seeker.resume.workingExperience">
      <h3 class="title">Lastest Job Title</h3>
      <div class="tag-lists">
        <input type="text" class="input" v-model="forms.title" />
      </div>
    </div>
    <div class="cv-card" v-if="resumes.seeker.resume.workingExperience">
      <h3 class="title">Lastest Salary</h3>
      <div class="tag-lists">
        <select class="input" v-model="forms.salaryRange">
          <option selected value disabled>Select Salary</option>
          <option v-for="(i, idx) in salaryInfo" :key="idx" :value="i._id">
            {{ i.name }}
          </option>
        </select>
      </div>
    </div>

    <div class="cv-card" v-if="resumes.seeker.resume.workingExperience">
      <h3 class="title">Previous Job Title</h3>
      <ul class="tag-lists">
        <li v-for="(jobtitle, index) in forms.pre" :key="index">
          <input
            v-model="forms.pre[index].name"
            type="text"
            class="input"
            @keyup.enter="AddJobTitle()"
          />
          <div class="option" v-if="index !== 0">
            <i class="fas fa-trash" @click="forms.pre.splice(index, 1)"></i>
          </div>
        </li>
        <button class="button info" @click="AddJobTitle()">
          Add Previous Job Title
        </button>
      </ul>
    </div>

    <div class="cv-card" v-if="resumes.seeker.resume.workingExperience">
      <h3 class="title">Previous Employer</h3>
      <ul class="tag-lists">
        <li v-for="(employer, index) in forms.previousE" :key="index">
          <input
            v-model="forms.previousE[index].name"
            type="text"
            class="input"
            @keyup.enter="AddEmployer()"
          />
          <div class="option" v-if="index !== 0">
            <i
              class="fas fa-trash"
              @click="forms.previousE.splice(index, 1)"
            ></i>
          </div>
        </li>
        <button class="button info" @click="AddEmployer()">
          Add Previous Job Title
        </button>
      </ul>
    </div>

    <div class="cv-card" v-if="resumes.seeker.resume.workingExperience">
      <h3 class="title">Previous Employer's Industry</h3>
      <ul class="tag-lists">
        <li
          v-for="(industry, index) in forms.previousEmployerIndustryId"
          :key="index"
        >
          <select
            class="input"
            v-model="forms.previousEmployerIndustryId[index]"
          >
            <option selected value disabled>Select latest Industry Type</option>
            <option
              v-for="(i, idx) in employerIndustry"
              :key="idx"
              :value="i._id"
            >
              {{ i.name }}
            </option>
          </select>
          <div class="option" v-if="index !== 0">
            <i
              class="fas fa-trash"
              @click="forms.previousEmployerIndustryId.splice(index, 1)"
            ></i>
          </div>
        </li>
        <button class="button info" @click="AddIndustry()">
          Add Previous Employer's Industry
        </button>
      </ul>
    </div>

    <div class="cv-card">
      <h3 class="title">Education</h3>
      <ul class="tag-lists">
        <li v-for="(i, index) in forms.education" :key="index">
          <div class="input-group">
            <p>
              <input
                type="text"
                v-model="forms.education[index].department"
                class="input"
              />
            </p>
            <p class="select">
              <select required v-model="forms.education[index].degreeId">
                <option disabled value>Select Degree</option>
                <option v-for="(d, inx) in degrees" :value="d._id" :key="inx">
                  {{ d.name }}
                </option>
              </select>
            </p>
          </div>
          <div class="option" v-if="index !== 0">
            <i
              class="fas fa-trash"
              @click="forms.education.splice(index, 1)"
            ></i>
          </div>
        </li>
        <button class="button info" @click="AddEducation()">
          Add Field of Study
        </button>
      </ul>
    </div>

    <div class="cv-card">
      <h3 class="title">Language</h3>
      <div class="tag-lists">
        <li v-for="(language, index) in forms.lan" :key="index">
          <div class="input-group">
            <p class="select">
              <select required v-model="forms.lan[index].LanguageId">
                <option selected value disabled>Select Languge</option>
                <option
                  v-for="(la, indx) in languages"
                  :value="la._id"
                  :id="la._id"
                  :key="indx"
                >
                  {{ la.name }}
                </option>
              </select>
            </p>
            <p class="select">
              <select required v-model="forms.lan[index].LanguageLevelId">
                <option disabled value>Select Level</option>
                <option
                  v-for="le in levels"
                  :key="le._id"
                  :value="le._id"
                  :id="le._id"
                >
                  {{ le.name }}
                </option>
              </select>
            </p>
          </div>
          <div class="option" v-if="index !== 0">
            <i class="fas fa-trash" @click="forms.lan.splice(index, 1)"></i>
          </div>
        </li>
        <button class="button info" @click="AddLanguage()">Add Language</button>
      </div>
    </div>

    <div class="cv-card">
      <h3 class="title">Key Skill</h3>
      <ul class="tag-lists">
        <li v-for="(skill, index) in forms.key.keySkill" :key="index">
          <input
            type="text"
            v-model="forms.key.keySkill[index].name"
            class="input"
          />
          <div class="option" v-if="index !== 0">
            <i
              class="fas fa-trash"
              @click="forms.key.keySkill.splice(index, 1)"
            ></i>
          </div>
        </li>
        <button class="button info" @click="AddSkill()">Add Skill</button>
      </ul>
    </div>

    <div class="cv-card">
      <h3 class="title">Job Level</h3>
      <ul class="tag-lists">
        <li>
          <select class="input" v-model="forms.jobLevelId">
            <option selected value="">Select Job Level</option>
            <option v-for="(i, idx) in jobLevelInfo" :key="idx" :value="i._id">
              {{ i.name }}
            </option>
          </select>
        </li>
      </ul>
    </div>

    <div class="cv-card">
      <h3 class="title">Job Function</h3>
      <selctJobFunction
        v-model="forms.jobFunctionId"
        :updateText="jobFunctions"
      />
      <!-- <ul class="tag-lists">
            <li v-for="(j, index) in forms.jobFunctionId" :key="index">
              <select class="input" v-model="forms.jobFunctionId[index]">
                <option selected value disabled> Select Job Function </option>
                <option v-for="(i, idx) in jobFunctionInfo" :key="idx" :value="i._id">
                  {{ i.name }}
                </option>
              </select>
              <div class="option">
                <i class="fas fa-trash" @click="forms.jobFunctionId.splice(index, 1)"></i>
              </div>
            </li>
            <button class="button info" @click="AddJobFunction()">
              Add Job Function
            </button>
          </ul> -->
    </div>

    <div class="cv-card">
      <h3 class="title">Skill Tags</h3>
      <ul class="tag-lists">
        <li v-for="(j, index) in forms.skillTagId" :key="index">
          <select class="input" v-model="forms.skillTagId[index]">
            <option selected value disabled>Select Skill Tags</option>
            <option v-for="(i, idx) in skillTagInfo" :key="idx" :value="i._id">
              {{ i.name }}
            </option>
          </select>
          <div class="option">
            <i
              class="fas fa-trash"
              @click="forms.skillTagId.splice(index, 1)"
            ></i>
          </div>
        </li>
        <button class="button info" @click="addSkillTag()">
          Add Skill Tags
        </button>
      </ul>
    </div>

    <div class="cv-card">
      <h3 class="title">Additional Tags</h3>
      <ul class="tag-lists">
        <li v-for="(j, index) in forms.additionalTagId" :key="index">
          <select class="input" v-model="forms.additionalTagId[index]">
            <option selected value disabled>Select Additional Tags</option>
            <option
              v-for="(i, idx) in additionalTagInfo"
              :key="idx"
              :value="i._id"
            >
              {{ i.name }}
            </option>
          </select>
          <div class="option">
            <i
              class="fas fa-trash"
              @click="forms.additionalTagId.splice(index, 1)"
            ></i>
          </div>
        </li>
        <button class="button info" @click="addAdditionalTag()">
          Add Additional Tags
        </button>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { apolloClient } from "@/services/apollo-client";
import { REUSE } from "@/graphql/manage/query";
import selctJobFunction from "../../others/selectJobFunction";
export default {
  components: {
    selctJobFunction,
  },
  props: ["resumes"],
  data() {
    return {
      forms: {
        title: "",
        file: {},
        pre: [{ name: "" }],
        previousE: [{ name: "" }],
        previousEmployerIndustryId: [""],
        total: null,
        key: {
          keySkill: [{ name: "" }],
        },
        jobLevelId: "",
        point: 1,
        salaryRange: "",
        jobFunctionId: [""],
        jobFunctionInfo: [],
        skillTagId: [""],
        additionalTagId: [""],
        lan: [{ LanguageId: "", LanguageLevelId: "" }],
        education: [{ department: "", degreeId: "" }],
      },
      employerIndustry: [],
      degrees: [],
      languages: [],
      levels: [],
      uploaded: false,
      name: null,
      error: null,
      expon: false,
      jobLevelInfo: [],
      jobFunctionInfo: [],
      salaryInfo: [],
      skillTagInfo: [],
      additionalTagInfo: [],
      jobFunctions: [],
    };
  },
  methods: {
    async queryLevel() {
      const res = await apolloClient.query({
        query: REUSE,
        variables: {
          type: "LanguageLevel",
        },
      });
      this.levels = res.data.getReuses;
    },
    async queryLanguage() {
      const res = await apolloClient.query({
        query: REUSE,
        variables: {
          type: "Language",
        },
      });
      this.languages = res.data.getReuses;
    },
    async queryDegree() {
      const res = await apolloClient.query({
        query: REUSE,
        variables: {
          type: "Degree",
        },
      });
      this.degrees = res.data.getReuses;
    },
    async queryIndustry() {
      const res = await apolloClient.query({
        query: REUSE,
        variables: {
          type: "Industry",
        },
      });
      this.employerIndustry = res.data.getReuses;
    },
    async queryJobLevel() {
      const res = await apolloClient.query({
        query: REUSE,
        variables: {
          type: "JobLevel",
        },
      });
      this.jobLevelInfo = res.data.getReuses;
    },
    async queryJobFunction() {
      const res = await apolloClient.query({
        query: REUSE,
        variables: {
          type: "JobFunction",
        },
      });
      this.jobFunctionInfo = res.data.getReuses;
    },
    async querySkillTag() {
      const res = await apolloClient.query({
        query: REUSE,
        variables: {
          type: "SkillTag",
        },
      });
      this.skillTagInfo = res.data.getReuses;
    },
    async queryAdditionalTag() {
      const res = await apolloClient.query({
        query: REUSE,
        variables: {
          type: "AdditionalTag",
        },
      });
      this.additionalTagInfo = res.data.getReuses;
    },
    async salaryQuery() {
      const res = await apolloClient.query({
        query: REUSE,
        variables: {
          type: "SalaryRange",
        },
      });
      this.salaryInfo = res.data.getReuses;
    },
    //Add more
    AddJobTitle() {
      this.forms.pre.push({ name: "" });
    },
    AddEmployer() {
      this.forms.previousE.push({ name: "" });
    },
    AddIndustry() {
      this.forms.previousEmployerIndustryId.push([""]);
    },
    AddJobFunction() {
      this.forms.jobFunctionId.push([""]);
    },
    addSkillTag() {
      this.forms.skillTagId.push([""]);
    },
    addAdditionalTag() {
      this.forms.additionalTagId.push([""]);
    },
    AddLanguage() {
      this.forms.lan.push({ LanguageId: "", LanguageLevelId: "" });
    },
    AddEducation() {
      this.forms.education.push({ department: "", degreeId: "" });
    },
    AddSkill() {
      this.forms.key.keySkill.push({ name: "" });
    },
    async selectFile() {
      this.uploaded = true;
      const input = this.$refs.fileinput;
      const files = input.files;

      const file = files[0];
      // console.log(file)
      const formData = new FormData();
      // console.log(file)
      formData.append("file", file);
      if (file) {
        const filesize = file.size / 1024;
        // console.log(filesize, "KB")
        const size = 5 * 1024;
        if (file && filesize < size) {
          if (
            file["type"] === "application/pdf" ||
            file["type"] ===
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
            file["type"] ===
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          ) {
            const res = await axios.post(
              `${process.env.VUE_APP_HTTPS_ADMIN}/client-api/upload-resume`,
              formData
            );
            if (res.data) {
              this.error = null;
            }
            this.forms.file = res.data;
            this.name = file.name;
          } else {
            this.error = "The file must be .PDF, .DOCX, .XLSX";
            this.forms.file = null;
            this.name = null;
          }
        } else {
          this.error = "The file Size is too much";
          this.forms.file = null;
          this.name = null;
        }
      }
    },
    findJobLevel() {
      const mapper = this.jobLevelInfo.find(
        (i) => i._id === this.forms.jobLevelId
      );
      this.forms.point = mapper.score ? mapper.score : 1;
    },
  },

  watch: {
    forms: {
      handler(val) {
        this.$emit("input", val);
      },
      immediate: true,
      deep: true,
    },
    "forms.jobLevelId": {
      handler(val) {
        if (val) {
          if (!val) return;
          setTimeout(() => {
            this.findJobLevel();
          }, 500);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.queryLanguage();
    this.queryDegree();
    this.queryIndustry();
    this.salaryQuery();
    this.queryLevel();
    this.queryJobLevel();
    this.queryJobFunction();
    this.querySkillTag();
    this.queryAdditionalTag();
    if (this.resumes.seeker.resume.workingExperience) {
      this.jobFunctions = this.resumes.seeker.resume.jobFunctionId;
      this.forms = {
        professionalSummary:
          this.resumes.seeker.registerSeeker.professionalSummary,
        title: this.resumes.seeker.resume.workingExperience.LatestJobTitle,

        pre: this.resumes.seeker.resume.workingExperience.previousJobTitlesId.map(
          (p) => ({
            name: p.name,
          })
        ),
        previousE:
          this.resumes.seeker.resume.workingExperience.previousEmployersId.map(
            (e) => ({
              name: e.name,
            })
          ),
        previousEmployerIndustryId:
          this.resumes.seeker.resume.workingExperience.previousEmployerIndustryId.map(
            (i) => i._id
          ),
        // total: this.data.totalWorkingExperience
        lan: this.resumes.seeker.resume.languageSkill.map((i) => ({
          LanguageId: i.LanguageId._id,
          LanguageLevelId: i.LanguageLevelId._id,
        })),
        education: this.resumes.seeker.resume.education.map((i) => ({
          department: i.department,
          degreeId: i.degreeId._id,
        })),
        key: {
          keySkill: this.resumes.seeker.resume.keySkillIds.map((a) => ({
            name: a.name,
          })),
        },
        jobLevelId: this.resumes.seeker.resume.jobLevelId
          ? this.resumes.seeker.resume.jobLevelId._id
          : "",
        jobFunctionId: this.resumes.seeker.resume.jobFunctionId,
        skillTagId: this.resumes.seeker.resume.skillTagId.map((s) => s._id),
        additionalTagId: this.resumes.seeker.resume.additionalTagId.map(
          (a) => a._id
        ),
        salaryRange: this.resumes.seeker.resume.workingExperience.SalayRangeId
          ._id
          ? this.resumes.seeker.resume.workingExperience.SalayRangeId._id
          : "",
        file: {},
      };
    } else {
      this.jobFunctions = this.resumes.seeker.resume.jobFunctionId;
      this.forms = {
        professionalSummary:
          this.resumes.seeker.registerSeeker.professionalSummary,

        lan: this.resumes.seeker.resume.languageSkill.map((i) => ({
          LanguageId: i.LanguageId._id,
          LanguageLevelId: i.LanguageLevelId._id,
        })),
        education: this.resumes.seeker.resume.education.map((i) => ({
          department: i.department,
          degreeId: i.degreeId._id,
        })),
        key: {
          keySkill: this.resumes.seeker.resume.keySkillIds.map((a) => ({
            name: a.name,
          })),
        },
        jobLevelId: this.resumes.seeker.resume.jobLevelId
          ? this.resumes.seeker.resume.jobLevelId._id
          : "",
        jobFunctionId: this.resumes.seeker.resume.jobFunctionId,
        skillTagId: this.resumes.seeker.resume.skillTagId.map((s) => s._id),
        additionalTagId: this.resumes.seeker.resume.additionalTagId.map(
          (a) => a._id
        ),
        file: {},
      };
    }
    // if (this.resumes) {
    //   this.forms = {
    //     professionalSummary:
    //       this.resumes.seeker.registerSeeker.professionalSummary,
    //     title: this.resumes.seeker.resume.workingExperience.LatestJobTitle ? this.resumes.seeker.resume.workingExperience.LatestJobTitle : "",

    //     pre: this.resumes.seeker.resume.workingExperience.previousJobTitlesId.map(
    //       (p) => ({
    //         name: p.name,
    //       })
    //     ) ?this.resumes.seeker.resume.workingExperience.previousJobTitlesId.map(
    //       (p) => ({
    //         name: p.name,
    //       })
    //     ):'',
    //     previousE:
    //       this.resumes.seeker.resume.workingExperience.previousEmployersId.map(
    //         (e) => ({
    //           name: e.name,
    //         })
    //       )? this.resumes.seeker.resume.workingExperience.previousEmployersId.map(
    //         (e) => ({
    //           name: e.name,
    //         })
    //       ):'',
    //     previousEmployerIndustryId:
    //       this.resumes.seeker.resume.workingExperience.previousEmployerIndustryId.map(
    //         (i) => i._id
    //       )? this.resumes.seeker.resume.workingExperience.previousEmployerIndustryId.map(
    //         (i) => i._id
    //       ):'',
    //     // total: this.data.totalWorkingExperience
    //     lan: this.resumes.seeker.resume.languageSkill.map((i) => ({
    //       LanguageId: i.LanguageId._id,
    //       LanguageLevelId: i.LanguageLevelId._id,
    //     })),
    //     education: this.resumes.seeker.resume.education.map((i) => ({
    //       department: i.department,
    //       degreeId: i.degreeId._id,
    //     })),
    //     key: {
    //       keySkill: this.resumes.seeker.resume.keySkillIds.map((a) => ({
    //         name: a.name,
    //       })),
    //     },
    //     file: {},
    //   };
    // } else {
    // }
  },
};
</script>

<style lang="scss" scoped>
.cv-card {
  margin-bottom: 20px;
  .title {
    font-size: var(--md-font);
    margin-bottom: 10px;
  }
}

.tag-lists {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;

  li {
    flex-grow: 1;
    width: 100%;
    list-style-type: none;
    display: flex;
    align-items: center;
    margin: 0;

    i {
      margin-left: 10px;
    }

    span {
      list-style-type: none;
      cursor: pointer;
      padding: 5px 10px;
      background-color: var(--info-color);
      color: var(--font-color);
      margin-right: 5px;
      margin-bottom: 5px;
    }

    .input-group {
      flex-grow: 1;
      display: flex;
      gap: 5px;
      p {
        margin: 0;
        flex-grow: 1;

        &.select {
          flex-grow: 1;
          margin: 0;
          select {
            width: 100%;
          }
        }
      }
    }
  }

  // li
}

.uploader {
  border: 1px dashed var(--border-color);
  display: flex;
  gap: 20px;
  align-items: center;
  padding: 20px;
  cursor: pointer;

  input {
    display: none;
  }

  &:hover i {
    color: var(--primary-color);
  }

  &:hover h3 {
    color: var(--primary-color);
  }

  i {
    color: var(--text-color);
    font-size: 2rem;
    cursor: pointer;
  }

  .upload-button-group {
    cursor: pointer;

    h3 {
      font-size: var(--md-font);
      margin: 0;
      color: var(--text-color);
    }

    p {
      font-size: var(--xsm-font);
      color: var(--text-grey-color);
    }
  }
}
</style>
